import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { flagIconStyle, marginRightStyle } from "./svg_flag_icon.module.scss";

const SVGFlagIcon = ({ altText, countryCode, small, marginRight }) => {
  const width = small ? 20 : 24;
  const height = small ? 15 : 18;

  const iconClassNames = classNames(flagIconStyle, {
    [marginRightStyle]: marginRight,
  });

  const countryCodeLowerCase = countryCode?.toLowerCase();

  if (countryCodeLowerCase) {
    return (
      <svg
        className={iconClassNames}
        viewBox="0 0 640 480"
        preserveAspectRatio="xMidYMid slice"
        width={width}
        height={height}
        alt={altText}
        data-testid="flag-icon"
      >
        <use
          xlinkHref={`/img/flags/4x3/${countryCodeLowerCase}.svg#flag-icon-css-${countryCodeLowerCase}`}
        />
      </svg>
    );
  }
  return null;
};

SVGFlagIcon.defaultProps = {
  altText: "Flag icon",
  small: false,
  marginRight: false,
};

SVGFlagIcon.propTypes = {
  altText: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  small: PropTypes.bool,
  marginRight: PropTypes.bool,
};

export default SVGFlagIcon;
